const config = {
  mediaUrl: `${process.env.REACT_APP_API_MEDIA_URL}`,
  apiUrl: `${process.env.REACT_APP_API_URL}`,
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

export default config;
